import { render, staticRenderFns } from "./OptOut.vue?vue&type=template&id=0bef7cfa&scoped=true"
import script from "./OptOut.vue?vue&type=script&lang=js"
export * from "./OptOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bef7cfa",
  null
  
)

export default component.exports